import { ORDER_STATUS_COLORS, ORDER_STATUS_MAP, OrderStatus } from "@project/shared-types";

const get_status_order = (status_key: OrderStatus) => {
  return ORDER_STATUS_COLORS[status_key];
};
const get_status_name_order = (status_key: OrderStatus) => {
  return ORDER_STATUS_MAP[status_key];
};

const parseDate = (dateString: string) => {
  const parsedDate = new Date(dateString);
  if (!isNaN(parsedDate.getTime())) {
    const day = parsedDate.getDate().toString().padStart(2, "0");
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
    const year = parsedDate.getFullYear();
    return `${year}-${month}-${day}`;
  } else {
    return "";
  }
};
const getParamFromURL = (paramName: string, defaultValue: string, location_search: string) => {
  const params = new URLSearchParams(location_search);
  const value = params.get(paramName);
  console.log(value);
  if (value) return value;
  return defaultValue;
};

const setParamInURL = (paramName: string, paramValue: string) => {
  // Получаем текущий URL
  let url = window.location.href;

  // Создаем новый URLSearchParams объект на основе текущего URL
  let searchParams = new URLSearchParams(window.location.search);

  // Устанавливаем значение параметра в URLSearchParams
  searchParams.set(paramName, paramValue);

  // Получаем строку параметров
  let paramString = searchParams.toString();

  // Заменяем старую строку параметров на новую в URL
  url = url.split("?")[0] + "?" + paramString;

  // Обновляем URL в истории браузера без перезагрузки страницы
  window.history.pushState({ path: url }, "", url);
};

const convertFileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      // reader.result содержит данные в формате base64
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};
const formatLastOnline = (timestamp: number) => {
  const now = new Date();
  const lastOnlineDate = new Date(timestamp * 1000); // Преобразование в миллисекунды
  const yesterday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 1
  );
  const twoDaysAgo = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - 2
  );
  const optionsDate = { year: "numeric", month: "long", day: "numeric" };
  const formattedDate = lastOnlineDate.toLocaleDateString("ru-RU", optionsDate as any);

  // Форматируем время
  const optionsTime = { hour: "2-digit", minute: "2-digit" };
  const formattedTime = lastOnlineDate.toLocaleTimeString("ru-RU", optionsTime as any);

  if (lastOnlineDate > twoDaysAgo && lastOnlineDate < yesterday) {
    // Если дата lastOnline вчера
    return "Вчера";
  } else if (lastOnlineDate.toDateString() === now.toDateString()) {
    // Если дата lastOnline сегодня
    return formattedTime;
  } else {
    // Во всех остальных случаях
    return formattedDate;
  }
};
export {
  convertFileToBase64,
  formatLastOnline,
  get_status_name_order,
  get_status_order,
  getParamFromURL,
  parseDate,
  setParamInURL
};

